var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessGreenBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8174 12.2224L83.788 79.78L39.8223 74.5539L33.2084 73.7685L31.7161 73.5906L31.6133 73.5792L31.8614 71.4943L32.077 69.6885L36.0476 36.2648L39.4353 7.7587L39.641 6.02319L53.1529 7.62809L91.8174 12.2224Z",
    fill: "#00A868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7015 62.1881C69.5953 62.1881 69.4974 62.1179 69.4664 62.0101L54.188 8.06232C54.1505 7.93171 54.2272 7.7962 54.3562 7.76028C54.4868 7.72273 54.6223 7.79946 54.6582 7.92844L69.9382 61.8762C69.9757 62.0068 69.899 62.1424 69.77 62.1783C69.7455 62.1848 69.7243 62.1881 69.7015 62.1881Z",
    fill: "#1D232A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0622 67.8306L36.9487 73.9677L33.2083 73.5188L33.3683 71.6347L36.0474 35.9073L38.2107 7.06975L39.5332 6.4624L54.4246 7.99546L70.0622 67.8306Z",
    fill: "#1D232A",
    stroke: "#1D232A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7863 8.83276e-05L0.5 11.428L15.2971 77.8346L66.5834 66.4067L51.7863 8.83276e-05Z",
    fill: "#E8E9EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8458 22.2745C10.7332 22.2745 10.632 22.1961 10.6075 22.0834C10.5781 21.9512 10.6613 21.8206 10.7936 21.7912L46.8638 13.752C46.996 13.721 47.1266 13.8059 47.156 13.9381C47.1854 14.0704 47.1021 14.201 46.9699 14.2304L10.8997 22.2696C10.8817 22.2728 10.8638 22.2745 10.8458 22.2745Z",
    fill: "#1D232A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1906 32.7938C13.0779 32.7938 12.9767 32.7154 12.9522 32.6027C12.9228 32.4705 13.0061 32.3399 13.1383 32.3105L49.2085 24.2713C49.3391 24.2403 49.4713 24.3252 49.5007 24.4574C49.5301 24.5897 49.4469 24.7203 49.3146 24.7497L13.2444 32.7872C13.2265 32.7905 13.2085 32.7938 13.1906 32.7938Z",
    fill: "#1D232A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5348 43.3114C15.4221 43.3114 15.3209 43.233 15.2964 43.1203C15.267 42.9881 15.3503 42.8575 15.4825 42.8281L51.5528 34.7889C51.685 34.7595 51.8156 34.8427 51.845 34.975C51.8744 35.1072 51.7912 35.2378 51.6589 35.2672L15.5887 43.3048C15.5707 43.3081 15.5528 43.3114 15.5348 43.3114Z",
    fill: "#1D232A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8793 53.8289C17.7666 53.8289 17.6654 53.7522 17.6409 53.6379C17.6115 53.5057 17.6948 53.375 17.827 53.3457L53.8973 45.3064C54.0295 45.277 54.1601 45.3603 54.1895 45.4926C54.2189 45.6248 54.1356 45.7554 54.0034 45.7848L17.9332 53.824C17.9136 53.8273 17.8956 53.8289 17.8793 53.8289Z",
    fill: "#1D232A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2223 64.3463C20.1096 64.3463 20.0084 64.2695 19.9839 64.1553C19.9545 64.023 20.0378 63.8924 20.1701 63.863L45.6231 58.1895C45.7537 58.1601 45.886 58.2434 45.9154 58.3756C45.9448 58.5079 45.8615 58.6385 45.7293 58.6679L20.2762 64.3414C20.2582 64.3446 20.2403 64.3463 20.2223 64.3463Z",
    fill: "#1D232A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_39_3640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2142 95.9999C88.3131 95.9999 96.4999 87.8131 96.4999 77.7142C96.4999 67.6153 88.3131 59.4285 78.2142 59.4285C68.1153 59.4285 59.9285 67.6153 59.9285 77.7142C59.9285 87.8131 68.1153 95.9999 78.2142 95.9999Z",
    fill: "#E8E9EA"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1786 86.9406C74.7134 86.9406 74.2451 86.7717 73.8766 86.4308L67.7839 80.8003C67.0054 80.0802 66.9578 78.8672 67.6764 78.0887C68.3965 77.3102 69.6095 77.2626 70.388 77.9812L75.0711 82.3097L85.9314 70.5573C86.6515 69.7788 87.8645 69.7312 88.643 70.4498C89.4215 71.17 89.4691 72.383 88.7505 73.1614L76.5882 86.3233C76.2105 86.7333 75.6961 86.9406 75.1786 86.9406Z",
    fill: "#00A868"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_39_3640",
    x: 56.9285,
    y: 58.4285,
    width: 42.5715,
    height: 42.5715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0 0.333333 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_3640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_3640",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessGreenBook);
export default __webpack_public_path__ + "static/media/successGreenBook.e0c978922e0bd9fb566f2df1aab686bc.svg";
export { ForwardRef as ReactComponent };